import {$, T} from "../../common/drupal/drupal";
/**
 * Class de gestion du header mobile
 */
class Header {

    /**
     * init
     */
    init(){
        const $block = $('#block-languages-switcher');
        const $list = $block.find('ul.links');
        const $active = $block.find('a.is-active');
        //$block.prepend($active);
        $block.on('click', (e) => {
            //e.preventDefault();
            $list.toggleClass('open');
        })

        $('.Header-burger').on('click', function() {
            $(this).closest('body').toggleClass('js-nav-opened');
        });
        //$block.prepend($active);

    }

    languageSwitcher() {

    }



    /**
     * Attach.
     * @param context
     */
    attach(context) {
      if(T.contextIsRoot(context)) {
        this.init();
      }
    }
}

export let header = new Header();
